"use client";

import { getQueryClient } from "./packages/utils/get-query-client";
import { QueryClientProvider } from "@tanstack/react-query";
// import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { Toaster } from "sonner";
import { ReactNode } from "react";
import { ThemeProvider } from "./context/useThemeContext";

export default function Providers({ children }: { children: ReactNode }) {
  const queryClient = getQueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        {children}
        <Toaster position="top-right" richColors />
        {/* <ReactQueryDevtools /> */}
      </ThemeProvider>
    </QueryClientProvider>
  );
}
